import {en} from "./translations.en";
import {fr} from "./translations.fr";

export const translations = {
  en: {
    profile: en,
  },
  fr: {
    profile: fr,
  },
};
